import { render } from "./headerView.vue?vue&type=template&id=10f36572"
const script = {}

import "./headerView.vue?vue&type=style&index=0&id=10f36572&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__